import React, { useEffect, useRef } from 'react';
import './AurelixEdge.css';

export default function AurelixEdge() {
  const sectionRef = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('ap-edge-visible');
          }
        });
      },
      { threshold: 0.1 }
    );

    const elements = sectionRef.current?.querySelectorAll('.ap-edge-reveal');
    elements?.forEach((el) => observer.observe(el));

    return () => {
      elements?.forEach((el) => observer.unobserve(el));
    };
  }, []);

  const pills = [
    'Performance Marketing',
    'Ad Creative & Production',
    'Data & Analytics',
    'Web & UI/UX',
    'AI & Automation',
    'CRO',
  ];

  const items = [
    {
      num: '01',
      title: 'Creative-level ROAS tracking',
      desc: 'Every rupee traced from ad to purchase. No black boxes.',
    },
    {
      num: '02',
      title: 'Agentic AI workflows',
      desc: 'Reporting, retargeting & ops — automated, zero lag.',
    },
    {
      num: '03',
      title: 'Fortune 100 analytics rigour',
      desc: 'AA-grade data discipline applied to your D2C brand.',
    },
  ];

  return (
    <section className="ap-edge-section" ref={sectionRef}>
      <div className="ap-edge-inner">
        <div className="ap-edge-cards-row">

          {/* Left card: 10-person in-house team */}
          <div className="ap-edge-card ap-edge-reveal">
            <div>
              <p className="ap-edge-card-title">10-Person In-House Team</p>
              <div className="ap-edge-pills">
                {pills.map((pill) => (
                  <span key={pill} className="ap-edge-pill">{pill}</span>
                ))}
              </div>
            </div>
            <p className="ap-edge-copy">
              No outsourcing. No white-labelling.{' '}
              <span className="scroll-hl" style={{ '--hl-d': '0s' }}>One team. Full accountability.</span>
            </p>
          </div>

          {/* Right card: The Aurelix Edge */}
          <div className="ap-edge-card ap-edge-reveal">
            <p className="ap-edge-card-title">The Aurelix Edge</p>
            <div className="ap-edge-list">
              {items.map((item) => (
                <div key={item.num} className="ap-edge-item">
                  <span className="ap-edge-item-num">{item.num}</span>
                  <div className="ap-edge-item-content">
                    <h4 className="ap-edge-item-title">{item.title}</h4>
                    <p className="ap-edge-item-desc">{item.desc}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>

        </div>
      </div>
    </section>
  );
}
